// @givmo/board — the reader's clock, for the pages whose content changes at a known instant.
//
// The signing chip counts its window down on it, and a meeting's pages read it to tell whether the
// meeting has started (CBG-FIX25): from then on nobody is asked whether they can make it.

import { useEffect, useState } from 'react';

/**
 * The reader's clock, re-read at each minute boundary — and at `until`, when sooner — so a countdown
 * moves on the minute and a window hides the moment it closes.
 */
export function useMinuteClock(until: string | null): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const untilMs = until === null ? Number.NaN : Date.parse(until);
    const toMinute = 60000 - (now % 60000);
    const toUntil = Number.isNaN(untilMs) ? Number.POSITIVE_INFINITY : untilMs - now;
    const wait = Math.max(250, Math.min(toMinute, toUntil > 0 ? toUntil : toMinute));
    const timer = window.setTimeout(() => setNow(Date.now()), wait);
    return () => window.clearTimeout(timer);
  }, [now, until]);
  return now;
}
